import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBButton extends Mixins(SBComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public disable!: boolean;

    @Prop({
        type: String,
        default: "",
    })
    public href!: string;

    @Prop({
        type: String,
        default: "",
    })
    public to!: string;

    @Prop({
        type: String,
        default: "",
    })
    public size!: string;

    @Emit("click")
    public click() {
    }

    public onButtonClick() {
        if (this.disable) return;
        this.$emit("click");
    }

}
